export const SHARE_URL = 'https://www.arcadia.com/advocate';

export const CITY_LEVEL = 'locality';
export const STATE_LEVEL = 'administrativeArea1';
